module.exports = __webpack_public_path__ + "img/galery-inge-v6-2-zoom.f1e3eccd.jpg";